module.exports = __webpack_public_path__ + "img/gastos_2.ef90a06c.png";